import { takeEvery, takeLatest } from 'redux-saga/effects';

import * as aiAssistantActions from '../actions';

import {
    createAISessionSaga,
    sendMessageSaga,
    getAnswerSaga,
    createFeedbackSaga,
    closeAISessionSaga,
    sendEmailCloseAISessionSaga,
    getHistoryChatSaga,
    getChatSessionDetailsSaga,
    getChatSessionsByIdSaga,
    getChatHistoryPaginatedSaga,
    submitAiAssistantMessageSaga,
    saveAiAssistantFeedbackSaga,
    getAiAssistantFeedbackSaga,
    getAiAssistantHealthSaga,
    getAiAssistantSuggestionsSaga,
    saveAiPolicyAcceptanceSaga,
    getAiAssistantFaqsSaga,
    getAiAssistantChatsSaga,
    getAiAssistantChatByIdSaga,
    createAiAssistantChatSaga,
    continueAiAssistantChatSaga,
    exportAiAssistantConversationSaga,
    renameAiAssistantChatSaga,
    deleteAiAssistantChatSaga,
} from './aiAssistant';

/**
 * Root saga for `AI Assistant`
 * Triggers sagas related to ai assistant
 *
 * @method aiAssistantSaga
 * @type   {Generator}
 */
function* aiAssistantSaga() {
    yield takeLatest(aiAssistantActions.createAISession.TRIGGER, createAISessionSaga);
    yield takeLatest(aiAssistantActions.sendMessage.TRIGGER, sendMessageSaga);
    yield takeLatest(aiAssistantActions.getAnswer.TRIGGER, getAnswerSaga);
    yield takeLatest(aiAssistantActions.createFeedback.TRIGGER, createFeedbackSaga);
    yield takeLatest(aiAssistantActions.closeAISession.TRIGGER, closeAISessionSaga);
    yield takeLatest(
        aiAssistantActions.sendEmailCloseAISession.TRIGGER,
        sendEmailCloseAISessionSaga
    );
    yield takeLatest(aiAssistantActions.getHistoryChat.TRIGGER, getHistoryChatSaga);
    yield takeLatest(aiAssistantActions.getChatSessionDetails.TRIGGER, getChatSessionDetailsSaga);
    yield takeLatest(aiAssistantActions.getChatSessionsById.TRIGGER, getChatSessionsByIdSaga);
    yield takeLatest(
        aiAssistantActions.getChatHistoryPaginated.TRIGGER,
        getChatHistoryPaginatedSaga
    );
    yield takeLatest(
        aiAssistantActions.submitAiAssistantMessage.TRIGGER,
        submitAiAssistantMessageSaga
    );
    yield takeEvery(
        aiAssistantActions.saveAiAssistantFeedback.TRIGGER,
        saveAiAssistantFeedbackSaga
    );
    yield takeEvery(aiAssistantActions.getAiAssistantFeedback.TRIGGER, getAiAssistantFeedbackSaga);
    yield takeLatest(aiAssistantActions.getAiAssistantHealth.TRIGGER, getAiAssistantHealthSaga);
    yield takeLatest(
        aiAssistantActions.getAiAssistantSuggestions.TRIGGER,
        getAiAssistantSuggestionsSaga
    );
    yield takeLatest(aiAssistantActions.saveAiPolicyAcceptance.TRIGGER, saveAiPolicyAcceptanceSaga);
    yield takeLatest(aiAssistantActions.getAiAssistantFaqs.TRIGGER, getAiAssistantFaqsSaga);
    yield takeLatest(aiAssistantActions.getAiAssistantChats.TRIGGER, getAiAssistantChatsSaga);
    yield takeLatest(aiAssistantActions.getAiAssistantChatById.TRIGGER, getAiAssistantChatByIdSaga);
    yield takeLatest(aiAssistantActions.createAiAssistantChat.TRIGGER, createAiAssistantChatSaga);
    yield takeLatest(
        aiAssistantActions.continueAiAssistantChat.TRIGGER,
        continueAiAssistantChatSaga
    );
    yield takeEvery(
        aiAssistantActions.exportAiAssistantConversation.TRIGGER,
        exportAiAssistantConversationSaga
    );
    yield takeLatest(aiAssistantActions.renameAiAssistantChat.TRIGGER, renameAiAssistantChatSaga);
    yield takeLatest(aiAssistantActions.deleteAiAssistantChat.TRIGGER, deleteAiAssistantChatSaga);
}

export default aiAssistantSaga;

export {
    createAISessionSaga,
    submitAiAssistantMessageSaga,
    saveAiAssistantFeedbackSaga,
    getAiAssistantFeedbackSaga,
    getAiAssistantHealthSaga,
    getAiAssistantSuggestionsSaga,
    saveAiPolicyAcceptanceSaga,
    getAiAssistantFaqsSaga,
    getAiAssistantChatsSaga,
    getAiAssistantChatByIdSaga,
    createAiAssistantChatSaga,
    continueAiAssistantChatSaga,
    exportAiAssistantConversationSaga,
    renameAiAssistantChatSaga,
    deleteAiAssistantChatSaga,
    sendMessageSaga,
    getAnswerSaga,
    createFeedbackSaga,
    closeAISessionSaga,
    sendEmailCloseAISessionSaga,
    getHistoryChatSaga,
    getChatSessionDetailsSaga,
    getChatSessionsByIdSaga,
    getChatHistoryPaginatedSaga,
};
